import React from 'react';
import PropTypes from 'prop-types';
import Anchor from '../../../commonComponents/Anchor';

export default function SignInLogo({ theme, logo }) {
  return (
    <div className="m-login__logo">
      <Anchor href="/">
        <img
          alt="logo"
          src={
            logo ||
            `/dist/${theme}/assets/demo/${theme}/media/img/logo/logo-dark.png`
          }
        />
      </Anchor>
    </div>
  );
}

SignInLogo.propTypes = {
  theme: PropTypes.string.isRequired,
  logo: PropTypes.string,
};

SignInLogo.defaultProps = {
  logo: null,
};
